import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Form as BsForm, Button, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { cleanCpfCnpj, validarCpfCnpj } from '~/Utils/Helpers';
import { listarGruposEmpresaConsultaCgcCpf } from '~/Services/Service';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

const filterSchema = Yup.object().shape({
  cgc_cpf: Yup.string()
    .required('Informe um CPF ou CNPJ')
    .test(
      'cpf-cnpj-valido',
      'Número digitado não representa CGC ou CPF válido.',
      (v) => validarCpfCnpj(v)
    ),
  codigo_grupo_empresa: Yup.number().nullable().integer().positive(),
});

const FilterSection = ({ onConsultar, onLimpar, loading }) => {
  const [geOptions, setGeOptions] = useState([]);

  useEffect(() => {
    listarGruposEmpresaConsultaCgcCpf()
      .then((res) => {
        const lista = Array.isArray(res) ? res : [];
        const opts = [{ value: null, label: 'Todos' }].concat(
          lista.map((g) => ({
            value: g.codigo_grupo_empresa,
            label: `${g.codigo_grupo_empresa} — ${g.apelido}`,
          }))
        );
        setGeOptions(opts);
      })
      .catch(() => toast.error('Erro ao carregar grupos de empresa.'));
  }, []);

  const initialValues = {
    cgc_cpf: '',
    codigo_grupo_empresa: null,
  };

  const handleSubmit = (values) => {
    const clean = cleanCpfCnpj(values.cgc_cpf);
    onConsultar({ cgc_cpf: clean, codigo_grupo_empresa: values.codigo_grupo_empresa });
  };

  const handleLimpar = (resetForm) => {
    resetForm({ values: initialValues });
    onLimpar();
  };

  return (
    <div className="card mb-3">
      <div className="card-body">
        <Formik
          initialValues={initialValues}
          validationSchema={filterSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, resetForm, isSubmitting }) => (
            <Form>
              <Row>
                <Col xs={12} md={5} lg={4}>
                  <BsForm.Group>
                    <BsForm.Label className="small mb-1">CPF / CGC</BsForm.Label>
                    <Field name="cgc_cpf">
                      {({ field }) => (
                        <BsForm.Control
                          {...field}
                          type="text"
                          placeholder="CPF / CGC"
                          onChange={(e) => {
                            setFieldValue('cgc_cpf', cleanCpfCnpj(e.target.value));
                          }}
                          maxLength={14}
                          autoFocus
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      name="cgc_cpf"
                      component="div"
                      className="text-danger small mt-1"
                    />
                  </BsForm.Group>
                </Col>
                <Col xs={12} md={4} lg={4}>
                  <BsForm.Group>
                    <BsForm.Label className="small mb-1">Grupo Empresa</BsForm.Label>
                    <Select
                      options={geOptions}
                      value={geOptions.find((o) => o.value === values.codigo_grupo_empresa) || geOptions[0]}
                      onChange={(opt) =>
                        setFieldValue('codigo_grupo_empresa', opt ? opt.value : null)
                      }
                      placeholder="Todos"
                      styles={customStyles}
                      components={{ DropdownIndicator }}
                      menuPortalTarget={document.body}
                    />
                  </BsForm.Group>
                </Col>
                <Col xs={12} md={3} lg={4}>
                  <BsForm.Group>
                    <BsForm.Label className="small mb-1 d-none d-md-block" aria-hidden="true">
                      &nbsp;
                    </BsForm.Label>
                    <div className="d-flex flex-wrap">
                      <Button
                        type="submit"
                        variant="primary"
                        disabled={loading || isSubmitting}
                        className="mr-2"
                      >
                        {loading ? 'Consultando...' : 'Consultar'}
                      </Button>
                      <Button
                        type="button"
                        variant="secondary"
                        onClick={() => handleLimpar(resetForm)}
                        disabled={loading}
                      >
                        Limpar
                      </Button>
                    </div>
                  </BsForm.Group>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default FilterSection;
